// extracted by mini-css-extract-plugin
export default {"heading":"page-heading_heading__DfN8D","evolved":"page-heading_evolved__22bUV"};